export default __webpack_public_path__ + "static/media/leap-icon.f683c037.svg";